import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Topheader from "../Topheader";
import Mainmenu from "../Mainmenu";
import CoursesNavbar from "../CoursesNabbar";
import Couses from "../Couses";
import Footer from "../Footer";
import ChapterBox from "../class 10/ChapterBox";
import Noteswritten from "../Noteswritten";
import { Helmet } from "react-helmet";
export default function Computer11() {
  const [selectedPdf, setSelectedPdf] = useState(null);
  const location = useLocation();

  // ✅ Close PDF automatically when navigating to another route
  useEffect(() => {
    setSelectedPdf(null);
  }, [location.pathname]);

  // ✅ Chapters with direct Google Drive PDF links (not preview)
  const chapters = [
    { no: 1, name: "Database Management System", pdflink: "https://drive.google.com/file/d/1VhBYkbjJRGOprpealtMs4ZcIKuEawdIF/preview" },
    { no: 2, name: "Data Communication and Networking", pdflink: "https://drive.google.com/file/d/1LPcs6PgPyfrmMjrKikWO5CLlm9SXcepC/preview" },
    { no: 3, name: "Web Technology II", pdflink: "" },
    { no: 4, name: "Programming in C", pdflink: "" },
    { no: 5, name: "Object Oriented Programming", pdflink: "https://docs.google.com/document/d/1PTKwFZSMqCg8oLAhnuzD1P6y28DtuoFLLUSfuv2HkvE/preview" },
    { no: 6, name: "Software Process Model", pdflink: "https://drive.google.com/file/d/1012nl8q5l66_du1PObnSX7zel0SouiYJ/preview" },
    { no: 7, name: "Recent Trends in Technology", pdflink: "" },
  ];
  

  return (
    <>
    <Helmet>
        <title>Class 11 Computer Science Notes | Online Paathshala</title>
        <meta name="description" content="Access Class 12 Computer Science NEB notes and important questions." />
        <meta property="og:title" content="Class 12 Computer Science Notes | Online Paathshala" />
        <meta property="og:description" content="Access Class 12 Computer Science NEB notes and important questions." />
        <meta property="og:image" content="https://www.onlinepaathshala.com/logo192.png" />
        <meta property="og:url" content="https://onlinepaathshala.com/enotes-class-11/enotes-class-11-computer-science" />
      </Helmet>
      {/* Header Section */}
      <div className="bg-slate-300 mt-5 pb-3 lg:pb-3 shadow-sm">
        <Noteswritten />
      </div>

      <div className="mt-3">
        <CoursesNavbar />
      </div>

      {/* Chapter List */}
      <div className="flex justify-center flex-wrap mt-5 gap-4">
        {chapters.map((chapter) => (
          <div
            key={chapter.no}
            onClick={() => chapter.pdflink && setSelectedPdf(chapter.pdflink)}
            className="cursor-pointer flex-1 min-w-[250px] max-w-[280px] flex"
          >
            <ChapterBox chapterNo={chapter.no} chapterName={chapter.name} />
          </div>
        ))}
      </div>

      {/* PDF Viewer Modal */}
      {selectedPdf && (
        <div
          className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 px-4"
          onClick={() => setSelectedPdf(null)} // ✅ Close when clicking background
        >
          <div
            className="bg-white rounded-lg shadow-lg w-full md:w-4/5 h-[80vh] flex flex-col"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
          >
            {/* Close Button */}
            <div className="flex justify-end p-2">
              <button
                onClick={() => setSelectedPdf(null)}
                className="px-4 py-2 bg-red-500 text-white rounded-lg shadow hover:bg-red-600 transition"
              >
                Close
              </button>
            </div>

            {/* PDF iframe */}
            <div className="flex-1">
              <iframe
                src={selectedPdf}
                className="w-full h-full border border-gray-300 rounded-b-lg"
                title="PDF Viewer"
              ></iframe>
            </div>
          </div>
        </div>
      )}

      <div className="mt-[120px]">
        <Footer />
      </div>
    </>
  );
}
